/**
 *         __       __               __
 *    ____/ /_ ____/ /______ _ ___  / /_
 *  / __  / / ___/ __/ ___/ / __ `/ __/
 * / /_/ / (__  ) / / /  / / /_/ / /
 * \__,_/_/____/_/ /_/  /_/\__, /_/
 *                           / /
 *                           \/
 * http://distriqt.com
 *
 * TwoTidy website (twotidy.com.au)
 *
 * @author  Shane Korin
 */

console.log('Starting...');

/* eslint-env browser */
(function() {
  'use strict';
  console.log('Started app');

  // Variables
  var windowHeight = $(window).height();
  var bannerHeight = $(".header-banner").innerHeight();
  var arrowAnimation = null;


  //
  // Initial setup

  $('#nav-home').scrollToFixed();
  $('.res-nav_click').click(function() {
    console.log('toggle nav');
    $('.main-nav').slideToggle();
    return false;
  });

  // Set up hero image banner
  $(document).ready(function () {


    var heroImageUrl = 'images/hero.jpg';
    if (window.location.href.indexOf('localhost') > -1) {
      heroImageUrl = '../images/hero.jpg';
    }

    // Load initial image
    var heroImage = document.getElementById('hero-image-hidden');
    heroImage.onload = function() {
      console.log('LOADED MAIN IMAGE');
      $("#heroImage").css({'background-image': 'url(' + heroImageUrl + ')'});
      setTimeout(animateIn, 1000);
    }
    heroImage.src = heroImageUrl;


    window.scrollTo(0, 0);
    $('html, body').scrollTop(0);

    $(window).bind('resizeEnd', function () {

      windowHeight = $(window).height();

      $(".hero-image").height(windowHeight);
      $(".hero-image-img").height(windowHeight);

      bannerHeight = $(".header-banner").innerHeight();
      var bmt = (windowHeight / 2) - (bannerHeight / 2);
      $(".header-banner").css({'margin-top': bmt + 'px'});
    });

    $(window).resize(function () {
      if (this.resizeTO) clearTimeout(this.resizeTO);
      this.resizeTO = setTimeout(function () {
        $(this).trigger('resizeEnd');
      }, 20);
    }).trigger("resize");

    // Nav click + scroll to anchor
    $('.scroll-click').bind('click', function(event) {
      var $anchor = $(this);
      var pos = $($anchor.attr('href')).offset().top;
      pos -= ($anchor.attr('href') === '#nav-home') ? 0 : 65;
      $('html, body').stop().animate({
        scrollTop: pos,
      }, 1000, 'easeInOutExpo');

      console.log('scrollClick: ', $anchor.attr('href'));
      if ($('.main-nav').css('display') === 'block') {
        $('.main-nav').slideToggle();
      }

      event.preventDefault();
    });

    var heightDiff = 250;
    var ww = $(window).width();
    if (ww > 1600) {
      heightDiff = 250;
    } else if (ww > 1200 && ww < 1599) {
      heightDiff = 180;
    } else if (ww > 800 && ww < 1199) {
      heightDiff = 100;
    }

    $.fn.isOnScreen = function(maxHeight) {
      var element = this.get(0);
      var bounds = element.getBoundingClientRect();
      return bounds.top < window.innerHeight && (bounds.bottom - heightDiff) > 0;
    }


    var wh = $(window).height();
    var images = [
      { name: 'image1' },
      { name: 'image2' },
      { name: 'image3' },
    ];

    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      img.element = $('#' + img.name);

      var startOffset = heightDiff / 2;
      img.element.css('transform', 'translateY(-' + startOffset + 'px)')
    }

    var headerImg = $('.hero-image-img');
    var imagePositions = [];

    function handleScroll() {
      var wh = $(window).height();
      var st = $(window).scrollTop();
      var scrollPos = st + wh;

      if (st < 0) {
        $('.hero-image-above').css({
          top: '-' + (380 + st) + 'px',
        });
      } else {
        $('.hero-image-above').css({ top: '-400px'});
      }

      // Scroll the header image
      if (st < (wh * 2)) {
        // console.log(st);
        var hpc = st / wh;
        var hval = hpc * (wh / 2);
        headerImg.css('transform', 'translateY(-' + hval + 'px)');
      }

      // Scroll the body feature images
      for (var i = 0; i < images.length; i++) {
        var img = images[i];
        var show = img.element.isOnScreen();

        if (show) {
          var cpos = imagePositions[i] || 0;
          var sp = img.element.offset().top;
          var ep = sp + $(window).height() + (img.element.height() - heightDiff);
          var pc = (scrollPos - sp) / (ep - sp);
          var val = (540 * pc) - 270;
          val -= 100;

          if (i === 0) {
            // var dif = val - cpos;
            // console.log('dif : ', dif);
          }

          imagePositions[i] = val;
          val = val * 0.5;

          // img.element.css('transform', 'translateY(' + val + 'px)');
          img.element.css('transform', 'translate3d(0, ' + val + 'px, 0)');
        }
      }
    }


    // Scrolling parallax stuff
    $(window).bind('scroll', function(ev) {
      handleScroll();
    });


    // Main animation to bring the site in at startup
    function animateIn() {

      handleScroll();

      $('body').css({
        'opacity': 1,
        'visibility': 'visible',
      });

      setTimeout(function() {
        $('.header-banner').css({'opacity': 1});
        $('.hero-image-img').css({
          'transform': 'scale(1)',
          'opacity': 1,
        });

        $('.down-arrow').css({'opacity': 1});
      }, 500);
    }

    setTimeout(function() {
      animateIn();
    }, 8000);
  });

  // end script
})();
